import { Button, Grid, Slider, Space, Toast } from "antd-mobile"
import { useCallback, useState } from "react"
import { getData, setData, DATA_TYPE } from "../../api/userData"

function Drank() {
  const [value, setValue] = useState(250)

  const onClick = useCallback(() => {
    const data = { value: getData(DATA_TYPE.WATER)?.value || [] }

    data.value = [
      ...data.value,
      {
        createdAt: new Date().toLocaleDateString(),
        value,
      },
    ]

    setData(DATA_TYPE.WATER, data)
    openNotification()
  }, [value])

  const openNotification = () => {
    Toast.show({
      content: "Добавлено",
      position: "bottom",
    })
  }

  const onChange = useCallback((data) => {
    setValue(data)
  }, [])

  return (
    <Grid
      columns={12}
      gap={12}
      style={{ marginLeft: 16, marginRight: 16, width: "100%" }}
    >
      <Grid.Item span={12}>
        <p style={{ textAlign: "center" }}>Вода: {value} мл</p>
      </Grid.Item>
      <Grid.Item span={12}>
        <Slider
          step={10}
          defaultValue={250}
          max={500}
          min={50}
          onChange={onChange}
        />
        <Space />
      </Grid.Item>
      <Grid.Item span={12}>
        <Space />
        <Button
          color="success"
          fill="outline"
          size="large"
          block
          onClick={onClick}
        >
          Добавить
        </Button>
      </Grid.Item>
    </Grid>
  )
}

export default Drank
